import React from 'react';
import {
    Box, Typography, TextField, Select, MenuItem, FormControl, InputLabel, Grid
} from '@mui/material';
import { Person } from '../../types/person'; // Importar o tipo Person

interface DirectorateChangeFormProps {
    people: Person[]; // Adicionar prop para receber a lista de pessoas
    newDirectorate: string;
    setNewDirectorate: (value: string) => void;
    justification: string;
    setJustification: (value: string) => void;
    isViewMode: boolean;
}

const DirectorateChangeForm: React.FC<DirectorateChangeFormProps> = ({
    people,
    newDirectorate,
    setNewDirectorate,
    justification,
    setJustification,
    isViewMode
}) => {
    return (
        <Box sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 2,
            mt: 3,
            backgroundColor: '#f8f9fa'
        }}>
            <Typography variant="subtitle1" sx={{ fontSize: '0.9rem', fontWeight: 'bold', mb: 2 }}>
                MUDANÇA DE DIRETORIA
            </Typography>

            <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small" margin="dense" disabled={isViewMode}>
                        <InputLabel id="directorate-select-label" sx={{ fontSize: '0.85rem' }}>Nova Diretoria *</InputLabel>
                        <Select
                            labelId="directorate-select-label"
                            value={newDirectorate}
                            label="Nova Diretoria *"
                            onChange={(e) => setNewDirectorate(e.target.value)}
                            sx={{ fontSize: '0.85rem', height: 40 }}
                        >
                            <MenuItem value="" sx={{ fontSize: '0.85rem' }}><em>-- Selecione uma diretoria --</em></MenuItem>
                            {people.map(person => (
                                <MenuItem key={person.id} value={person.id.toString()} sx={{ fontSize: '0.85rem' }}>
                                    {person.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Justificativa (Opcional)"
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        variant="outlined"
                        size="small"
                        margin="dense"
                        InputLabelProps={{ style: { fontSize: '0.85rem' } }}
                        InputProps={{ style: { fontSize: '0.85rem' }, sx: { height: 40 } }}
                        placeholder="Ex: Reorganização de equipes..."
                        disabled={isViewMode}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default DirectorateChangeForm;
